// ..\Statusfalgar\Statusfalgar.Abstractions\Interfaces\IArticlePriceStockModel.cs
export interface IArticlePriceStockModel {
    articleText: string;
    price: number;
    regularPrice?: number;
    quantityAvailable: number;
    quantityExternal: number;
    deliveryTime: string;
    deliveryDays?: number;
    isNew: boolean;
    estimatedDeliveryDate?: string;
}

// ..\Statusfalgar\Statusfalgar.Abstractions\Interfaces\IArticleShippingModel.cs
export interface IArticleShippingModel {
    articleId: number;
    productGroupId: number;
    quantity: number;
    price: number;
}

// ..\Statusfalgar\Statusfalgar.Abstractions\Interfaces\IArticleSize.cs
export interface IArticleSize {
    productGroupId: number;
    diameter?: number;
    width?: number;
    aspectRatio?: number;
    radial: boolean;
}

// ..\Statusfalgar\Statusfalgar.Abstractions\Interfaces\IExternalDataFetcher.cs
export interface IExternalDataFetcher {
}

// ..\Statusfalgar\Statusfalgar.Abstractions\Interfaces\IProductLink.cs
export interface IProductLink {
    id: number;
    brandName: string;
    modelName: string;
    size: string;
    productLink: string;
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\ArticlePriceChangeType.cs
export enum ArticlePriceChangeType {
    Manual = 0,
    Pricat = 1,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\CheckoutType.cs
export enum CheckoutType {
    Invoice = 0,
    Payer = 1,
    WireTransfer = 2,
    Svea = 3,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\EmailType.cs
export enum EmailType {
    Waybill = 1,
    Invoice = 2,
    StockList = 3,
    AccountReminder = 4,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\FreightType.cs
export interface FreightTypeMethods {
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\FreightType.cs
export enum FreightType {
    DHLFreight = 1,
    DHLServicePoint = 2,
    DHLEuroConnect = 3,
    UPS = 4,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\KitsetType.cs
export enum KitsetType {
    None = 0,
    Default = 1,
    Black = 2,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\OptionType.cs
export enum OptionType {
    None = 0,
    Assembly = 1,
    Tpms = 2,
    RimLock = 3,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\OrderStatus.cs
export enum OrderStatus {
    Order = 1,
    Processing = 2,
    Delivered = 3,
    Cancelled = 4,
    Invoiced = 5,
    Temporary = 6,
    Awaiting = 7,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\PackageCode.cs
export interface PackageCodeMethods {
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\PackageCode.cs
export enum PackageCode {
    Package = 1,
    Pallet = 2,
    Parcel = 3,
    Batch = 4,
    EuroPallet = 5,
    HalfPallet = 6,
    NordicFullPallet = 7,
    NordicHalfPallet = 8,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\PayerStatus.cs
export enum PayerStatus {
    None = 0,
    Authorized = 1,
    Settled = 2,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\PaymentStatus.cs
export enum PaymentStatus {
    Cancelled = 0,
    Created = 1,
    Final = 2,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\ProductGroupType.cs
export enum ProductGroupType {
    SummerTyre = 10,
    WinterTyre = 20,
    WinterStudded = 21,
    WinterStuddable = 22,
    SummerCTyre = 30,
    WinterCTyre = 40,
    WinterCStudded = 41,
    WinterCStuddable = 42,
    SummerInchTyre = 48,
    WinterInchTyre = 49,
    SteelRim = 210,
    AluminiumRim = 220,
    Accessories = 500,
    Other = 999,
}

// ..\Statusfalgar\Statusfalgar.Common\Enums\ProductType.cs
export enum ProductType {
    Tyre = 1,
    Rim = 2,
    Accessory = 3,
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ArticleAvailabilityInfo.cs
export interface ArticleAvailabilityInfo {
    id: number;
    articleId: string;
    articleText: string;
    ean?: number;
    manufacturerArticleNumber: string;
    supplierArticleId: string;
    brandId?: number;
    brandName: string;
    patternModelId?: number;
    patternModelName: string;
    productGroupId: number;
    productGroupName: string;
    price: number;
    consumerPrice?: number;
    discountPrice?: number;
    priceExclVat?: number;
    vatAmount?: number;
    quantityAvailable: number;
    quantityExternal: number;
    quantityOnPurchaseOrder: number;
    totalAvailableQuantity: number;
    estimatedDeliveryDate?: string;
    deliveryTime: string;
    externalDeliveryTime: string;
    isLocalStock: boolean;
    isExternalStock: boolean;
    isAvailable: boolean;
    availabilityStatus: number;
    width: string;
    aspectRatio: string;
    diameter: string;
    loadIndex: string;
    speedIndex: string;
    runFlat: string;
    reinforced: string;
    season: string;
    isWinterApproved?: boolean;
    fuelEfficiency: string;
    wetGrip: string;
    noise: string;
    noiseClass: string;
    numberOfBolts?: number;
    boltCircle: string;
    centerBore: string;
    offset: string;
    comment: string;
    isNew: boolean;
    isDeleted: boolean;
    dateAdded?: string;
    supplierId?: number;
    supplierName: string;
    recyclingFee?: number;
    imageUrl: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ArticleIdentifier.cs
export interface ArticleIdentifier {
    articleId?: number;
    ean?: number;
    manufacturerArticleId: string;
    buyerArticleId: string;
    supplierArticleId: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ArticleSearchCriteria.cs
export interface ArticleSearchCriteria {
    onlyLocalStockItems: boolean;
    includeCarTyres: boolean;
    includeAlloyRims: boolean;
    includeSteelRims: boolean;
    includeAccessories: boolean;
    includeDeleted: boolean;
    requireStock: boolean;
    productGroupId?: number;
    brandId?: number;
    supplierId?: number;
    skip?: number;
    take?: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ArticleSearchOptions.cs
export interface ArticleSearchOptions {
    searchByArticleId: boolean;
    searchByEan: boolean;
    searchByArticleText: boolean;
    searchByManufacturerArticleNumber: boolean;
    searchBySupplierArticleId: boolean;
    maxResults: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ArticlePriceChange\ArticlePriceChangeDto.cs
export interface ArticlePriceChangeDto {
    articleId: number;
    date: string;
    price: number;
    supplierId?: number;
    source: ArticlePriceChangeType;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\EmailQueue\AccountReminderEmailParameters.cs
export interface AccountReminderEmailParameters {
    customerName: string;
    deletionDate: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\EmailQueue\EmailQueueAddModel.cs
export interface EmailQueueAddModel {
    type: EmailType;
    parameters: any;
    emailAddress: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\EmailQueue\EmailQueueModel.cs
export interface EmailQueueModel {
    id: number;
    emailAddresses: string[];
    type: EmailType;
    parameters: any;
    created: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\EmailQueue\InvoiceEmailParameters.cs
export interface InvoiceEmailParameters {
    invoiceNumber: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\EmailQueue\WaybillEmailParameters.cs
export interface WaybillEmailParameters {
    orderId: number;
    paymentTypeId: number;
    paymentTypeCode: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\CartModel.cs
export interface CartModel {
    id: number;
    deliveryAddressId?: number;
    shippingPrice: number;
    shippingPriceExVat: number;
    vatAmount: number;
    totalExludingVat: number;
    totalAmount: number;
    requireMessage: boolean;
    expressCheckout: boolean;
    defaultCheckoutType?: CheckoutType;
    checkoutTypes: CheckoutType[];
    rows: CartRowModel[];
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\CartRowModel.cs
export interface CartRowModel extends IArticlePriceStockModel {
    id: number;
    articleId: number;
    articleText: string;
    imageId?: number;
    quantity: number;
    priceExVat: number;
    price: number;
    regularPrice?: number;
    quantityAvailable: number;
    quantityExternal: number;
    deliveryTime: string;
    deliveryDays?: number;
    estimatedDeliveryDate?: string;
    carModel: string;
    licensePlate: string;
    kType?: number;
    productType: ProductType;
    packageId?: number;
    packageRims: number[];
    reference: string;
    isNew: boolean;
    brandName: string;
    modelName: string;
    productLink: string;
    savedFilterQuery: string;
    tyreSizes: TyreSizeModel[];
    options: CartRowOptionModel[];
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\CartRowOptionModel.cs
export interface CartRowOptionModel {
    id: number;
    translation: string;
    infoTranslation?: string;
    selectedValue: number;
    locked: boolean;
    values: CartRowOptionValueModel[];
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\CartRowOptionValueModel.cs
export interface CartRowOptionValueModel {
    id: number;
    translation: string;
    infoTranslation?: string;
    price?: number;
    priceExVat?: number;
    quantityPerPackage: number;
    link: string;
    sortOrder: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\TyreSizeModels.cs
export interface TyreSizeModel {
    width: number;
    aspectRatio: number;
    diameter: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\TyreSizeModels.cs
export interface TyreWidthAspectRatiosModel {
    width: number;
    aspectRatios: number[];
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\ShoppingCart\TyreSizeModels.cs
export interface WidthAspectRatioModel {
    width: number;
    aspectRatio: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\StockFtpUpload\ArticleCsvModel.cs
export interface ArticleCsvModel extends IArticleCsv {
    articleId: number;
    productGroupId: number;
    articleText: string;
    brandName: string;
    modelName: string;
    color: string;
    extra: string;
    width?: number;
    aspectRatio?: number;
    diameter?: number;
    extraLoad?: boolean;
    runFlat?: boolean;
    speedIndex: string;
    loadIndex: string;
    fuelEfficiency: string;
    wetGrip: string;
    noiceClass: string;
    noiceValue?: number;
    numberOfBolts?: number;
    boltCircle: string;
    offset?: number;
    centerBore?: number;
    loadRating?: number;
    isWinterApproved?: boolean;
    isReplica?: boolean;
    price: number;
    dotYear?: number;
    ean?: number;
    imageId?: number;
    imageUrl: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\StockFtpUpload\ArticleStockCsvModel.cs
export interface ArticleStockCsvModel extends IStockCsv, IArticleCsv {
    articleId: number;
    productGroupId: number;
    articleText: string;
    brandName: string;
    modelName: string;
    color: string;
    extra: string;
    width?: number;
    aspectRatio?: number;
    diameter?: number;
    extraLoad?: boolean;
    runFlat?: boolean;
    speedIndex: string;
    loadIndex: string;
    fuelEfficiency: string;
    wetGrip: string;
    noiceClass: string;
    noiceValue?: number;
    numberOfBolts?: number;
    boltCircle: string;
    offset?: number;
    centerBore?: number;
    loadRating?: number;
    isWinterApproved?: boolean;
    isReplica?: boolean;
    quantityAvailable: number;
    quantityExternal: number;
    externalDeliveryTime: string;
    price: number;
    dotYear?: number;
    ean?: number;
    imageId?: number;
    imageUrl: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\StockFtpUpload\IArticleCsv.cs
export interface IArticleCsv {
    price: number;
    imageId?: number;
    imageUrl: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\StockFtpUpload\IStockCsv.cs
export interface IStockCsv {
    quantityAvailable: number;
    externalDeliveryTime: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\StockFtpUpload\StockCsvModel.cs
export interface StockCsvModel extends IStockCsv {
    articleId: number;
    ean?: number;
    quantityAvailable: number;
    quantityExternal: number;
    externalDeliveryTime: string;
    dotYear?: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\StockList\StockListModel.cs
export interface StockListModel {
    articleId: number;
    productGroupId: number;
    articleText: string;
    brandName: string;
    modelName: string;
    color: string;
    extra: string;
    width?: number;
    aspectRatio?: number;
    diameter?: number;
    extraLoad?: boolean;
    runFlat?: boolean;
    speedIndex: string;
    loadIndex: string;
    fuelEfficiency: string;
    wetGrip: string;
    noiceClass: string;
    noiceValue?: number;
    numberOfBolts?: number;
    boltCircle: string;
    offset?: number;
    centerBore?: number;
    loadRating?: number;
    isWinterApproved?: boolean;
    isReplica?: boolean;
    quantityAvailable: number;
    quantityExternal: number;
    externalDeliveryTime: string;
    price: number;
    dotYear?: number;
    ean?: number;
    imageId?: number;
    imageUrl: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\SveaOrder\SveaAddressModel.cs
export interface SveaAddressModel {
    fullName: string;
    firstName: string;
    lastName: string;
    streetAddress: string;
    streetAddress2: string;
    streetAddress3: string;
    coAddress: string;
    postalCode: string;
    city: string;
    countryCode: string;
    isGeneric: boolean;
    addressLines: any;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\SveaOrder\SveaCreateOrderModel.cs
export interface SveaCreateOrderModel {
    snippet: string;
    errorMessage: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\SveaOrder\SveaCustomerModel.cs
export interface SveaCustomerModel {
    id: number;
    nationalId: string;
    countryCode: string;
    isCompany: boolean;
    emailAddress: string;
    phoneNumber: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\SveaOrder\SveaOrderInfoModel.cs
export interface SveaOrderInfoModel {
    status: PaymentStatus;
    paymentType: string;
    jsonResponse: string;
    isInvoice: boolean;
    error: boolean;
    customer: SveaCustomerModel;
    billingAddress: SveaAddressModel;
    shippingAddress: SveaAddressModel;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleChassiDto.cs
export interface VehicleChassiDto {
    id: number;
    upstepChassiId?: number;
    boltLength: string;
    minBoltLength: string;
    maxBoltLength: string;
    centreBore: number;
    centreBoreR?: number;
    chassisTitle: string;
    frontAxleWeight?: number;
    frontVehicleTrack: string;
    loadIndex?: number;
    loadIndexR?: number;
    manufacturerId: string;
    maxWheelLoad: number;
    maxWheelLoadR?: number;
    maxRimWidthFront: string;
    maxRimWidthRear: string;
    maxSpeed: string;
    maxEtFront?: number;
    maxEtRear?: number;
    minEtFront?: number;
    minEtRear?: number;
    maxRimWidth: string;
    nutBoltAm: string;
    nutBoltAmLength: string;
    nutBoltHex: string;
    nutBoltOeAlloy: string;
    nutBoltOeAlloyLength: string;
    nutBoltOeSteel: string;
    nutBoltOeSteelLength: string;
    nutBoltThreadType: string;
    nutBoltTorque: string;
    nutOrbolt: string;
    oeTyreDescription: string;
    pcd: string;
    rearAxleWeight?: number;
    rearVehicleTrack: string;
    rimOffset?: number;
    rimSize: string;
    rimSizeR: string;
    offsetR?: number;
    speedIndex: string;
    speedIndexR: string;
    tpms: string;
    tyrePressure?: number;
    tyrePressureR?: number;
    tyreSize: string;
    tyreSizeR: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleChassiTyreDto.cs
export interface VehicleChassiTyreDto {
    chassisId: number;
    modelName: string;
    modelId: string;
    tyreSize: string;
    loadIndex: string;
    speedIndex: string;
    tyrePressure: string;
    rimSize: string;
    rimOffset?: number;
    tyreSizeR: string;
    loadIndexR: string;
    speedIndexR: string;
    tyrePressureR: string;
    rimSizeR: string;
    offsetR?: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleDataDto.cs
export interface VehicleDataDto {
    kType: number;
    carName: string;
    constructionFrom?: string;
    constructionTo?: string;
    powerHpFrom: number;
    powerHpTo: number;
    powerKwFrom: number;
    powerKwTo: number;
    constructionType: string;
    impulsionType: string;
    modelName: string;
    fuelType: string;
    fuelTypeProcess: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleEngineDto.cs
export interface VehicleEngineDto {
    kType: number;
    name: string;
    powerHpFrom?: number;
    powerHpTo?: number;
    powerKwFrom?: number;
    powerKwTo?: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleInfoDto.cs
export interface VehicleInfoDto {
    kType: number;
    manufacturer: VehicleManufactureDto;
    model: VehicleModelDto;
    chassi: VehicleChassiDto;
    vehicle: VehicleDataDto;
    tyrePrimary: VehicleChassiTyreDto;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleManufactureCacheDto.cs
export interface VehicleManufactureCacheDto {
    id: number;
    name: string;
    show: boolean;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleManufactureDto.cs
export interface VehicleManufactureDto {
    id: number;
    name: string;
    displayName: string;
    show: boolean;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleModelCacheDto.cs
export interface VehicleModelCacheDto {
    id: number;
    name: string;
    constructedFrom: string;
    constructedTo?: string;
    show: boolean;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleModelDto.cs
export interface VehicleModelDto {
    id: number;
    name: string;
    displayName: string;
    constructedFrom: string;
    constructedTo?: string;
    show: boolean;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleRimSearchCriteriaDto.cs
export interface VehicleRimSearchCriteriaDto {
    diameterMin: number;
    diameterMax: number;
    offsetMin: number;
    offsetMax: number;
    widthMax: number;
    centerBore: number;
    boltCircle: string;
    numberOfBolts: number;
    maxWheelLoad: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleTyreSizeDto.cs
export interface VehicleTyreSizeDto {
    width: number;
    aspectRatio: number;
    diameter: number;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleUpstepAxle.cs
export enum VehicleUpstepAxle {
    All = 0,
    Front = 1,
    Rear = 2,
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\Vehicle\VehicleUpstepDto.cs
export interface VehicleUpstepDto {
    upstepId: number;
    chassisId: number;
    axle: VehicleUpstepAxle;
    wheelSize: string;
    rimWidth: number;
    rimDiameter: number;
    minOffset: number;
    maxOffset: number;
    comments: string;
    isUserAdded: boolean;
    exclude: boolean;
    tyreSizes: VehicleTyreSizeDto[];
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\WebOrder\CreateOrderModel.cs
export interface CreateOrderModel {
    deliveryAddressId?: number;
    languageCode: string;
    text: string;
    notifyReceiver: boolean;
    reference: string;
    contactPerson: string;
    checkoutType: CheckoutType;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\WebOrder\OrderCreatedModel.cs
export interface OrderCreatedModel {
    orderId: number;
    formAction: string;
    agentId: string;
    xmlWriter: string;
    data: string;
    charset: string;
    checksum: string;
    checkoutType: CheckoutType;
    currencyCode: string;
    amount: number;
    iban: string;
    swift: string;
}

// ..\Statusfalgar\StatusFalgar.BLL\Models\WebOrder\ShippingModel.cs
export interface ShippingModel extends IArticleShippingModel {
    articleId: number;
    productGroupId: number;
    quantity: number;
    price: number;
    priceExVat: number;
}

// ..\Statusfalgar\StatusFalgar\Models\AccountViewModels.cs
export interface LoginViewModel {
    email: string;
    password: string;
    rememberMe: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\AccountViewModels.cs
export interface RegisterViewModel {
    email: string;
    invoiceEmail: string;
    password: string;
    confirmPassword: string;
    customerType: string;
    identityNumber: string;
    vatNumber: string;
    companyName: string;
    firstname: string;
    lastname: string;
    contactPerson: string;
    telephone: string;
    address1: string;
    address2: string;
    zipcode: string;
    city: string;
    countryCode: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ArticleCriteriaModel.cs
export interface ArticleCriteriaModel {
    id: number;
    kType?: number;
    languageCode: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ArticleExternalStockListModel.cs
export interface ArticleExternalStockListModel {
    supplierId: number;
    supplierArticleId: string;
    quantity: number;
    dotYear?: number;
    totalPriceLocalCurrency: number;
    dateTime: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CarBrandModel.cs
export interface CarBrandModel {
    id: number;
    name: string;
    imageName: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CarEngineModel.cs
export interface CarEngineModel {
    kTypeId: number;
    name: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CarModelCriteriaModel.cs
export interface CarModelCriteriaModel {
    manufactureId: number;
    year?: number;
}

// ..\Statusfalgar\StatusFalgar\Models\CarModelGroup.cs
export interface CarModelGroup {
    name: string;
    models: CarModelModel[];
    years: number[];
}

// ..\Statusfalgar\StatusFalgar\Models\CarModelModel.cs
export interface CarModelModel {
    id: number;
    name: string;
    fromYear: number;
    toYear?: number;
}

// ..\Statusfalgar\StatusFalgar\Models\CartAddWheelPackageModel.cs
export interface CartAddWheelPackageModel {
    articles: CartAddWheelPackageArticleModel[];
    quantity: number;
    kType: number;
    licensePlate: string;
    packageId?: number;
}

// ..\Statusfalgar\StatusFalgar\Models\CartAddWheelPackageModel.cs
export interface CartAddWheelPackageArticleModel {
    articleId: number;
    savedFilterQuery: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CartExpressCheckoutModel.cs
export interface CartExpressCheckoutModel {
    countryCode: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CartRowEditModel.cs
export interface CartRowEditModel {
    id?: number;
    articleId: number;
    quantity: number;
    kType?: number;
    licensePlate: string;
    reference: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CartRowOptionEditModel.cs
export interface CartRowOptionEditModel {
    id: number;
    optionId: number;
    valueId: number;
}

// ..\Statusfalgar\StatusFalgar\Models\CarTyreSizeSearchModel.cs
export interface CarTyreSizeSearchModel {
    carModelId: number;
    rimWidth: number;
    diameter: number;
}

// ..\Statusfalgar\StatusFalgar\Models\ColorModel.cs
export interface ColorModel {
    id: number;
    name: string;
    hex: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ContactFormModel.cs
export interface ContactFormModel {
    name: string;
    email: string;
    phone: string;
    carInfo: string;
    message: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CountryModel.cs
export interface CountryModel {
    countryCode: string;
    name: string;
    currencyCode: string;
    isExport: boolean;
    isExportEu: boolean;
    includeVat: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\CurrencyModel.cs
export interface CurrencyModel {
    currencyCode: string;
    currencyRate: number;
}

// ..\Statusfalgar\StatusFalgar\Models\CustomerEditModel.cs
export interface CustomerEditModel {
    email: string;
    invoiceEmail: string;
    telephone: string;
    contactPerson: string;
    currentPassword: string;
    newPassword: string;
}

// ..\Statusfalgar\StatusFalgar\Models\CustomerModel.cs
export interface CustomerModel {
    id: number;
    name: string;
    email: string;
    invoiceEmail: string;
    telephone: string;
    creditLimit: number;
    isReseller: boolean;
    isCompany: boolean;
    export: boolean;
    exportEu: boolean;
    contactPerson: string;
    termsOfPayment: number;
    countryCode: string;
    currencyCode: string;
    hasReceipts: boolean;
    vatPercentage: number;
    vatNumber: string;
}

// ..\Statusfalgar\StatusFalgar\Models\DeliveryAddressCreateModel.cs
export interface DeliveryAddressCreateModel {
    name: string;
    address1: string;
    address2: string;
    zipCode: string;
    city: string;
    countryCode: string;
    contactPerson: string;
    telephone: string;
    defaultAddress: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\DeliveryAddressDetailsModel.cs
export interface DeliveryAddressDetailsModel {
    id: number;
    name: string;
    address1: string;
    address2: string;
    zipCode: string;
    city: string;
    countryCode: string;
    contactPerson: string;
    telephone: string;
    defaultAddress: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\DeliveryAddressEditModel.cs
export interface DeliveryAddressEditModel {
    id: number;
    defaultAddress: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\InvoiceAddressEditModel.cs
export interface InvoiceAddressEditModel {
    name: string;
    address1: string;
    address2: string;
    zipCode: string;
    city: string;
    countryCode: string;
    contactPerson: string;
}

// ..\Statusfalgar\StatusFalgar\Models\InvoiceModel.cs
export interface InvoiceModel {
    invoiceNumber: number;
    createDate: string;
    dueDate: string;
    payDate?: string;
    termsOfPayment: number;
    totalAmount: number;
    balance: number;
    currencyCode: string;
    isPayed: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\InvoiceRowModel.cs
export interface InvoiceRowModel {
    articleId: number;
    description: string;
    quantity: number;
    priceExcludingVat: number;
    priceIncludingVat: number;
}

// ..\Statusfalgar\StatusFalgar\Models\OrderConfirmationInfoModel.cs
export interface OrderConfirmationInfoModel {
    checkoutType?: CheckoutType;
    currencyCode: string;
    totalAmount: number;
    shippingPrice: number;
    iban: string;
    swift: string;
    snippet: string;
    rows: OrderRowInfoModel[];
}

// ..\Statusfalgar\StatusFalgar\Models\OrderConfirmationRequestModel.cs
export interface OrderConfirmationRequestModel {
    orderId: number;
    validationId: string;
}

// ..\Statusfalgar\StatusFalgar\Models\OrderInfoModel.cs
export interface OrderInfoModel {
    id: number;
    currencyCode: string;
    shippingPrice: number;
    vatAmount: number;
    totalAmount: number;
    rows: OrderInfoRowModel[];
}

// ..\Statusfalgar\StatusFalgar\Models\OrderInfoModel.cs
export interface OrderInfoRowModel {
    articleId: number;
    description: string;
    brandName: string;
    productGroupName: string;
    quantity: number;
    price: number;
}

// ..\Statusfalgar\StatusFalgar\Models\OrderModel.cs
export interface OrderModel {
    id: number;
    createDate: string;
    deliveryDate?: string;
    statusId: number;
    shippingExcludingVat: number;
    shippingIncludingVat: number;
    totalAmountExcludingVat: number;
    vatAmount: number;
    totalAmountIncludingVat: number;
    termsOfPayment: string;
    hasReceipt: boolean;
}

// ..\Statusfalgar\StatusFalgar\Models\OrderRowInfoModel.cs
export interface OrderRowInfoModel {
    articleId: number;
    description: string;
    quantity: number;
    price: number;
}

// ..\Statusfalgar\StatusFalgar\Models\OrderRowModel.cs
export interface OrderRowModel {
    articleId: number;
    description: string;
    quantity: number;
    priceExcludingVat: number;
    priceIncludingVat: number;
    carModel: string;
    reference: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ReceiptModel.cs
export interface ReceiptModel {
    id: number;
    createDate: string;
    statusId: number;
    shippingExcludingVat: number;
    shippingIncludingVat: number;
    totalAmountExcludingVat: number;
    vatAmount: number;
    totalAmountIncludingVat: number;
}

// ..\Statusfalgar\StatusFalgar\Models\ResetPasswordModel.cs
export interface ResetPasswordModel {
    email: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ResponseModel.cs
export interface ResponseModel {
    error: ErrorCode;
    errorMessage: string;
    result: boolean;
    data: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ResponseModel.cs
export enum ErrorCode {
    None = 0,
    AlreadyExist = 1,
    Unauthorized = 2,
    InvalidData = 3,
    NotFound = 4,
}

// ..\Statusfalgar\StatusFalgar\Models\RimBoltPatternModel.cs
export interface RimBoltPatternModel {
    numberOfBolts: number;
    boltCircle: number;
}

// ..\Statusfalgar\StatusFalgar\Models\RimSearchModel.cs
export interface RimSearchCriteraModel {
    boltNumber?: number;
    boltCircle?: number;
    diameter?: number;
    kTypeId?: number;
    licensePlate: string;
    licenseCountryCode: string;
    description: string;
    languageCode: string;
}

// ..\Statusfalgar\StatusFalgar\Models\RimSearchResultModel.cs
export interface RimSearchResultModel {
    carInfo: VehicleInfoModel;
    articles: ArticleModel[];
}

// ..\Statusfalgar\StatusFalgar\Models\RimTyresSearchModel.cs
export interface RimTyresSearchModel {
    kTypeId: number;
    articleId: number;
}

// ..\Statusfalgar\StatusFalgar\Models\ShoppingListAddToCartModel.cs
export interface ShoppingListAddToCartModel {
    linkId: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ShoppingListCreateModel.cs
export interface ShoppingListCreateModel {
    name: string;
}

// ..\Statusfalgar\StatusFalgar\Models\ShoppingListModel.cs
export interface ShoppingListModel {
    name: string;
    articleCount: number;
}

// ..\Statusfalgar\StatusFalgar\Models\SitemapArticleModel.cs
export interface SitemapArticleModel {
    productLink: string;
    lastChanged: string;
}

// ..\Statusfalgar\StatusFalgar\Models\SitemapProductGroupModel.cs
export interface SitemapProductGroupModel {
    id: number;
    name: string;
}

// ..\Statusfalgar\StatusFalgar\Models\SveaCheckoutResponseModel.cs
export interface SveaCheckoutResponseModel {
    snippet: string;
    orderId: number;
    currencyCode: string;
    shippingPrice: number;
    totalAmount: number;
    rows: OrderRowInfoModel[];
}

// ..\Statusfalgar\StatusFalgar\Models\TyreSearchModel.cs
export interface TyreSearchModel {
    tyreType: number;
    width?: number;
    aspectRatio?: number;
    diameter?: number;
    description: string;
}

// ..\Statusfalgar\StatusFalgar\Models\VehicleChassiModel.cs
export interface VehicleChassiModel {
    pcd: string;
    centreBore: number;
    maxWheelLoad: number;
    tpms: boolean;
    boltLength: string;
    nutOrbolt: string;
    nutBoltThreadType: string;
    nutBoltTorque: string;
    nutBoltHex: string;
}

// ..\Statusfalgar\StatusFalgar\Models\VehicleDataModel.cs
export interface VehicleDataModel {
    carName: string;
    fromYear?: number;
    toYear?: number;
    powerHp: number;
    powerKw: number;
    constructionType: string;
    impulsionType: string;
    modelName: string;
    fuelType: string;
    fuelTypeProcess: string;
}

// ..\Statusfalgar\StatusFalgar\Models\VehicleInfoModel.cs
export interface VehicleInfoModel {
    kTypeId: number;
    manufactureName: string;
    modelName: string;
    wheel: VehicleWheelModel;
    chassi: VehicleChassiModel;
    vehicle: VehicleDataModel;
}

// ..\Statusfalgar\StatusFalgar\Models\VehicleWheelModel.cs
export interface VehicleWheelModel {
    tyreSize: string;
    tyreSizeR: string;
    loadIndex: string;
    loadIndexR: string;
    speedIndex: string;
    tyrePressure: string;
    tyrePressureR: string;
    rimSize: string;
    rimSizeR: string;
    rimOffset?: number;
    offsetR?: number;
}

// ..\Statusfalgar\StatusFalgar\Models\Article\ArticleDetails.cs
export interface ArticleDetails {
    description: string;
    images: number[];
    aspectRatio?: number;
    loadRating?: number;
    numberOfBolts?: number;
    boltCircle: string;
    centerBore?: number;
}

// ..\Statusfalgar\StatusFalgar\Models\Article\ArticleModel.cs
export interface ArticleModel extends IArticlePriceStockModel, IProductLink {
    id: number;
    imageId?: number;
    articleText: string;
    productGroupId: number;
    fuelEfficiency: string;
    wetGrip: string;
    noiceClass: string;
    noiceValue?: number;
    price: number;
    regularPrice?: number;
    quantityAvailable: number;
    quantityExternal: number;
    deliveryTime: string;
    deliveryDays?: number;
    isNew: boolean;
    estimatedDeliveryDate?: string;
    size: string;
    productLink: string;
    defaultQuantity: number;
    brandName: string;
    modelName: string;
    extraLoad: boolean;
    runFlat: boolean;
    threePmsf: boolean;
    speedIndexCode: string;
    loadIndex: string;
    diameter?: number;
    width?: number;
    offset?: number;
    colorId?: number;
    isWinterApproved: boolean;
    axle?: VehicleUpstepAxle;
    comments: string;
    articleDetails: ArticleDetails;
}

// ..\Statusfalgar\StatusFalgar\Models\GoogleProductFeed\Entry.cs
export interface Entry {
    id: string;
    title: string;
    description: string;
    link: string;
    imageLink: string;
    condition: string;
    availablity: string;
    availabilityDate: string;
    price: string;
    brand: string;
    mpn: string;
    shipping: Shipping[];
    googleProductCategory: string;
    productType: string;
    color: string;
}

// ..\Statusfalgar\StatusFalgar\Models\GoogleProductFeed\Feed.cs
export interface Feed {
    title: string;
    link: string;
    updated: string;
    entries: Entry[];
}

// ..\Statusfalgar\StatusFalgar\Models\GoogleProductFeed\Shipping.cs
export interface Shipping {
    country: string;
    service: string;
    price: string;
}
